<div class="topbar d-flex flex-wrap align-items-center bg-light px-3 py-2 shadow">
  <div class="d-flex align-items-center flex-grow-1">
    <button class="menu-toggle btn btn-outline-primary btn-sm d-flex align-items-center justify-content-center me-2"
      (click)="toggleSidebar()" aria-label="Toggle Sidebar">
      <span class="menu-icon">&#9776;</span>
    </button>
    <h4 class="m-0 fw-bold">AYUDAS IASD</h4>
  </div>

  <div class="ms-auto d-flex align-items-center">
    <div class="me-3 position-relative" style="cursor: pointer;" (click)="navigateToNotifications()">
      <i class="fas fa-bell fa-lg text-secondary"></i>
      <span *ngIf="unreadCount > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
        {{ unreadCount }}
      </span>
    </div>
    <div class="d-flex align-items-center border rounded px-2 py-1 position-relative"
      style="min-width: 240px; max-width: 300px;">
      <!-- Icono y datos -->
      <i class="fas fa-user-circle text-secondary me-2" style="font-size: 1.5rem;"></i>
      <div class="me-auto">
        <div class="fw-semibold text-dark" style="font-size: 0.8rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100px; display: block;">
          {{ userName }}
        </div>
        <div class="text-muted" style="font-size: 0.7rem;">{{ roleId }}</div>
      </div>

      <!-- Botón de dropdown -->
      <button class="btn btn-sm py-0 px-2" (click)="isDropdownOpen = !isDropdownOpen">
        <i class="fas fa-caret-down" style="font-size: 0.8rem;"></i>
      </button>

      <!-- Menú desplegable -->
      <ul *ngIf="isDropdownOpen"
        class="position-absolute list-unstyled bg-white shadow-sm px-2 py-1 mt-1 rounded border"
        style="right: 0; top: 100%; min-width: 150px; z-index: 1050;">
        <li class="py-1 px-2 hover:bg-light border-bottom" (click)="routeToProfile()">Perfil</li>
        <li class="py-1 px-2 hover:bg-light border-bottom">Configuración</li>
        <li class="py-1 px-2 text-danger" (click)="logout()">
          <i class="fas fa-sign-out-alt me-1"></i> Cerrar sesión
        </li>
      </ul>
    </div>
  </div>
</div>